console.log("Rink Customizer - Indoor Branding Update Loaded!");
function getCartCount() {
  try {
    const storedCart = localStorage.getItem('cir_cart');
    if (storedCart) {
      const cart = JSON.parse(storedCart);
      return cart.reduce((total, item) => total + item.quantity, 0);
    }
  } catch (e) {}
  return 0;
}

function syncBadge() {
  const badge = document.getElementById('cart-badge');
  if (badge) {
    badge.textContent = getCartCount();
  }
}

function toggleCartDrawer(isOpen) {
  if (isOpen) {
    window.location.href = '/cart';
  }
}

// Resolve a preview image filename to its Shopify asset URL. RC_ASSET_BASE is
// set by the section template (the theme's /assets/ base URL).
function rcAsset(file) {
  return (window.RC_ASSET_BASE || 'media/rinkdesigner/') + file;
}

function closeCartOnOverlay(event) {}

syncBadge();

const customizer = document.querySelector('[data-rink-customizer]');
if (customizer) {
  const config = {
    size: 'club',
    format: 'rental',
    type: 'outdoor',
    outdoorBase: 'standard',
    branding: false,
    maintenance: false,
    accessories: new Set(['boards-perimeter'])
  };

  const sizeMap = {
    starter: { label: "20' x 40'", name: 'Starter', width: 45, ratio: '2 / 1', caption: 'Compact backyard training sheet' },
    club: { label: "40' x 80'", name: 'Club', width: 62, ratio: '2 / 1', caption: 'Large family and club-style outdoor sheet' },
    custom: { label: 'Custom footprint', name: 'Custom', width: 76, ratio: '2.28 / 1', caption: 'Custom engineered rink environment' }
  };

  const formatMap = {
    rental: 'Seasonal rental',
    purchase: 'Purchase portable rink',
    portable: 'Portable system'
  };

  const typeMap = {
    outdoor: 'Outdoor Refrigerated',
    indoor: 'Indoor Arena',
    synthetic: 'Synthetic Ice'
  };

  const outdoorBaseMap = {
    standard: 'Standard',
    pool: 'Pool-to-Rink',
    court: 'Court Conversion'
  };

  const mediaByAccessory = {
    netting: ['media/normal_protective_netting_sample_black_030.jpg', 'Protective perimeter netting detail'],
    lighting: ['media/cedar-canoe-books-huntsville-winterfest-outdoor-rink-aerial-night.webp', 'Event-grade rink lighting'],
    matting: ['media/rink-liner.png', 'Rubber matting and rink liner package'],
    bench: ['media/canadas-wonderland-winterfest-dasher-board-installation-crew.webp', 'Board and bench installation detail'],
    nets: ['media/goalie-nets.png', 'NHL-style goalie net accessory'],
    seal: ['media/seal-skate-aid-1.png', "Children's seal skate aid"],
    boards: ['media/canadas-wonderland-winterfest-dasher-board-installation-crew.webp', 'Dasher board perimeter installation']
  };

  const updateActiveButtons = (choice, value) => {
    customizer.querySelectorAll(`[data-choice="${choice}"]`).forEach((button) => {
      const active = button.dataset.value === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const renderCustomizer = () => {
    const size = sizeMap[config.size];
    const media = document.getElementById('customizer-media');
    const caption = document.getElementById('customizer-media-caption');
    let imageSrc = '';
    if (config.type === 'indoor') {
      const gameLines = config.accessories.has('markings-game');
      const hasBoards = config.accessories.has('boards');
      const hasPerimeter = config.accessories.has('boards-perimeter');
      const branding = config.branding;

      if (!hasPerimeter) {
        if (config.size === 'starter') imageSrc = rcAsset('customizer-indoor-small-no-boards.webp');
        else if (config.size === 'club') imageSrc = rcAsset('customizer-indoor-medium-no-boards.webp');
        else imageSrc = rcAsset('customizer-indoor-large-no-boards.webp');
      } else {
        if (config.size === 'starter') {
          if (gameLines && hasBoards) imageSrc = rcAsset('customizer-indoor-small-all-options.webp');
          else if (branding) imageSrc = rcAsset('customizer-indoor-small-logo-game-lines.webp');
          else if (hasBoards) imageSrc = rcAsset('customizer-indoor-small-board-branding-only.webp');
          else if (gameLines) imageSrc = rcAsset('customizer-indoor-small-game-lines-only.webp');
          else imageSrc = rcAsset('customizer-indoor-small-boards-blank.webp');
        } else if (config.size === 'club') {
          if (gameLines && hasBoards) imageSrc = rcAsset('customizer-indoor-medium-all-options.webp');
          else if (branding) imageSrc = rcAsset('customizer-indoor-medium-logo-game-lines.webp');
          else if (hasBoards) imageSrc = rcAsset('customizer-indoor-medium-board-branding-only.webp');
          else if (gameLines) imageSrc = rcAsset('customizer-indoor-medium-game-lines-only.webp');
          else imageSrc = rcAsset('customizer-indoor-medium-boards-blank.webp');
        } else {
          if (gameLines && hasBoards) imageSrc = rcAsset('customizer-indoor-large-all-options.webp');
          else if (branding) imageSrc = rcAsset('customizer-indoor-large-logo-game-lines.webp');
          else if (hasBoards) imageSrc = rcAsset('customizer-indoor-large-board-branding-only.webp');
          else if (gameLines) imageSrc = rcAsset('customizer-indoor-large-game-lines-only.webp');
          else imageSrc = rcAsset('customizer-indoor-large-boards-blank.webp');
        }
      }
    } else if (config.type === 'synthetic') {
      if (config.size === 'starter') imageSrc = rcAsset('center-ice-rinks-small-synthetic-ice-backyard-rink-aerial-estate.webp');
      else if (config.size === 'club') imageSrc = rcAsset('center-ice-rinks-medium-synthetic-ice-backyard-rink-aerial-estate.webp');
      else imageSrc = rcAsset('center-ice-rinks-large-synthetic-ice-backyard-rink-aerial-estate.webp');
    } else if (config.type === 'outdoor' && config.outdoorBase === 'standard') {
      if (config.size === 'starter') imageSrc = rcAsset('center-ice-rinks-rural-outdoor-hockey-rink-snowy-forest-aerial.webp');
      else if (config.size === 'club') imageSrc = rcAsset('center-ice-rinks-rural-outdoor-hockey-rink-aerial-empty.webp');
      else imageSrc = rcAsset('customemptyy.webp');
    } else {
      // Base images: empty rinks — used for pool/court conversions and custom size
      if (config.size === 'starter') imageSrc = rcAsset('center-ice-rinks-rural-outdoor-hockey-rink-snowy-forest-aerial.webp');
      else if (config.size === 'club') imageSrc = rcAsset('center-ice-rinks-rural-outdoor-hockey-rink-aerial-empty.webp');
      else imageSrc = rcAsset('customemptyy.webp');
    }
    
    const mediaSource = [imageSrc, size.caption];
    const accessoryCount = config.accessories.size;
    const maintenanceCopy = config.maintenance ? ' with maintenance and flooder support' : '';

    media.src = mediaSource[0];
    media.alt = mediaSource[1];
    if (caption) caption.textContent = '';
    document.getElementById('summary-size').textContent = size.label;
    document.getElementById('summary-format').textContent = formatMap[config.format];
    const outdoorOptions = document.getElementById('outdoor-options');
    if (outdoorOptions) {
      outdoorOptions.style.display = config.type === 'outdoor' ? 'block' : 'none';
    }

    let typeLabel = typeMap[config.type] || '';
    if (config.type === 'outdoor' && config.outdoorBase !== 'standard') {
      typeLabel = `${typeLabel} (${outdoorBaseMap[config.outdoorBase]})`;
    }

    const summaryTypeEl = document.getElementById('summary-type');
    if (summaryTypeEl) summaryTypeEl.textContent = typeLabel;

    const typeLinkMap = {
      outdoor: { href: '/pages/portable-refrigeration', text: 'Learn more about Outdoor rinks &rarr;' },
      indoor: { href: '/pages/indoor-rinks', text: 'Learn more about Indoor arenas &rarr;' },
      synthetic: { href: '/pages/synthetic-ice', text: 'Learn more about Synthetic Ice &rarr;' }
    };

    const outdoorBaseLinkMap = {
      pool: { href: '/pages/pool-to-rink', text: 'Learn more about Pool conversions &rarr;' },
      court: { href: '/pages/tennis-court-to-rink', text: 'Learn more about Court conversions &rarr;' }
    };

    const learnMoreEl = document.getElementById('type-learn-more');
    if (learnMoreEl && typeLinkMap[config.type]) {
      learnMoreEl.href = typeLinkMap[config.type].href;
      learnMoreEl.innerHTML = typeLinkMap[config.type].text;
    }

    const outdoorLearnMoreEl = document.getElementById('outdoor-learn-more');
    if (outdoorLearnMoreEl) {
      if (config.type === 'outdoor' && outdoorBaseLinkMap[config.outdoorBase]) {
        outdoorLearnMoreEl.href = outdoorBaseLinkMap[config.outdoorBase].href;
        outdoorLearnMoreEl.innerHTML = outdoorBaseLinkMap[config.outdoorBase].text;
        outdoorLearnMoreEl.style.display = 'inline-block';
      } else {
        outdoorLearnMoreEl.style.display = 'none';
      }
    }
  };

  customizer.querySelectorAll('[data-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      config[button.dataset.choice] = button.dataset.value;
      updateActiveButtons(button.dataset.choice, button.dataset.value);
      renderCustomizer();
    });
  });

  customizer.querySelectorAll('[data-accessory]').forEach((input) => {
    input.addEventListener('change', () => {
      if (input.checked) {
        config.accessories.add(input.dataset.accessory);
      } else {
        config.accessories.delete(input.dataset.accessory);
      }
      renderCustomizer();
    });
  });

  customizer.querySelectorAll('[data-toggle]').forEach((input) => {
    input.addEventListener('change', () => {
      config[input.dataset.toggle] = input.checked;
      
      if (input.dataset.toggle === 'branding' && input.checked && config.type === 'indoor') {
        const gameLinesCheckbox = customizer.querySelector('[data-accessory="markings-game"]');
        if (gameLinesCheckbox && !gameLinesCheckbox.checked) {
          gameLinesCheckbox.checked = true;
          config.accessories.add('markings-game');
          const toggleCard = gameLinesCheckbox.closest('.toggle-card');
          if (toggleCard) toggleCard.classList.add('is-active');
        }
      }
      
      renderCustomizer();
    });
  });

  renderCustomizer();

  window.__rcGetConfig = function () {
    const sizeEl = document.getElementById('summary-size');
    const lengthInput = document.getElementById('custom-length');
    const widthInput = document.getElementById('custom-width');
    let sizeLabel = sizeMap[config.size] ? sizeMap[config.size].label : config.size;
    if (config.size === 'custom' && lengthInput && widthInput) {
      sizeLabel = lengthInput.value + "' x " + widthInput.value + "'";
    }
    return {
      size: config.size,
      sizeLabel: sizeLabel,
      format: config.format,
      formatLabel: formatMap[config.format] || config.format,
      type: config.type,
      typeLabel: typeMap[config.type] || config.type,
      outdoorBase: config.outdoorBase,
      outdoorBaseLabel: outdoorBaseMap[config.outdoorBase] || '',
      branding: config.branding,
      maintenance: config.maintenance,
      accessories: Array.from(config.accessories)
    };
  };

  window.__rcSubmitQuote = async function (btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    const c = window.__rcGetConfig();
    const accessoryLabels = {
      'boards-perimeter': 'Boards Perimeter', 'markings-game': 'Game Lines',
      'boards': 'Board Branding', 'netting': 'Protective Netting',
      'lighting': 'Lighting System', 'matting': 'Rubber Matting',
      'bench': 'Player Bench', 'nets': 'Goalie Nets', 'seal': 'Seal Skate Aids'
    };
    const accList = c.accessories.map(function(a){ return accessoryLabels[a] || a; }).join(', ') || 'None';
    let typeDetail = c.typeLabel;
    if (c.type === 'outdoor' && c.outdoorBase !== 'standard') typeDetail += ' (' + c.outdoorBaseLabel + ')';
    const body =
      'Source: Rink Customizer\n' +
      'Size: ' + c.sizeLabel + '\n' +
      'Usage: ' + c.formatLabel + '\n' +
      'Type: ' + typeDetail + '\n' +
      'Accessories: ' + accList + '\n' +
      'Custom Logo: ' + (c.branding ? 'Yes' : 'No') + '\n' +
      'Maintenance: ' + (c.maintenance ? 'Yes' : 'No');
    sessionStorage.setItem('ci_contact_ctx', JSON.stringify({
      ref: 'customizer',
      size: c.size,
      format: c.format,
      type: c.type,
      outdoorBase: c.outdoorBase,
      accessories: c.accessories
    }));
    window.location.href = '/pages/contact#contact';
  };

  window.__rcApplyParams = function (params) {
    if (params.type && config.hasOwnProperty('type')) {
      config.type = params.type;
      updateActiveButtons('type', params.type);
    }
    if (params.size && sizeMap[params.size]) {
      config.size = params.size;
      updateActiveButtons('size', params.size);
    }
    if (params.usage && formatMap[params.usage]) {
      config.format = params.usage;
      updateActiveButtons('format', params.usage);
    }
    renderCustomizer();
  };

  const sidebar = document.querySelector('.showcase-sidebar');
  if (sidebar) {
    customizer.addEventListener('wheel', (event) => {
      if (window.matchMedia('(max-width: 767px)').matches || event.ctrlKey) return;
      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
      if (sidebar.scrollHeight <= sidebar.clientHeight) return;

      const before = sidebar.scrollTop;
      sidebar.scrollTop += event.deltaY;

      if (sidebar.scrollTop !== before) {
        event.preventDefault();
      }
    }, { passive: false });
  }
}
